import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import AiBook from '../views/AI-book.vue'
import BookIndex from '../views/Book-index.vue'
import Book from '../views/Book.vue'
import CreateBook from '../views/CreateBook.vue'
import ModifyBook from '../views/ModifyBook.vue'
import Teacher from '../views/Teacher.vue'
import Disclaimer from '../views/Disclaimer.vue'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/ai_book',
    name: 'AI_Book',
    component: AiBook
  },
  {
    path: '/book_index/:studentId',
    name: 'Book_Index',
    component: BookIndex
  },
  {
    path: '/create_book',
    name: 'Create_Book',
    component: CreateBook
  },
  {
    path: '/modify_book/:bookId',
    name: 'Modify_Book',
    component: ModifyBook
  },
  {
    path: '/ai_book/:bookId',
    name: 'Book',
    component: Book
  },
  {
    path: '/teacher',
    name: 'Teacher',
    component: Teacher
  },
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: Disclaimer
  },

  { path: '*', redirect: { name: 'AI_Book' } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach(function (to, from, next) {
  setTimeout(() => {
    window.scrollTo(0, 0)
  }, 100)
  next()
})

export default router
